<div class="main" [ngClass]="{ 'is-portrait': isPortraitDevice }">
    <div class="container" [ngClass]="{ 'is-portrait': isPortraitDevice }">
        <div class="headlines">
            <h1 *ngIf="!isPortraitDevice" class="headline-m">
                {{ personalDataTitle | translate }}
            </h1>

            <p class="subtitle-m">
                {{ personalDataBirthSubtitle | translate }}
            </p>
        </div>

        <form class="form" [formGroup]="formGroup">
            <!-- birthDate -->
            <div class="form-row">
                <div class="form-field">
                    <p-calendar
                        id="birthDate"
                        class="birth-date"
                        type="date"
                        formControlName="birthDate"
                        dateFormat="dd/mm/yy"
                        [showIcon]="true"
                        [showOnFocus]="false"
                        ngDefaultControl
                        selectionMode="single"
                        inputId="buttondisplay"
                        placeholder="{{ birthDateLabel | translate }}"
                        (onSelect)="onChangeDate($event)"
                        (onClear)="onChangeDate($event)"
                        (onInput)="onChangeDate($event)"
                        (onClose)="onChangeDate($event)"
                    >
                    <!-- <ng-template pTemplate="date" let-date>
                        <span [ngStyle]="{textDecoration: (date.year > 21 && date.day > 10) ? 'line-through' : 'inherit'}">
                            {{date.day}}
                        </span>
                    </ng-template> -->
                    </p-calendar>
                    <div *ngIf="formGroup.get('birthDate')?.touched && formGroup.get('birthDate')?.errors?.edadInvalida">
                        Debes tener al menos 18 años.
                    </div>
                </div>
            </div>

            <!-- country -->
            <div class="form-row">
                <div class="form-field">
                    <p-dropdown
                        class="p-dropdown"
                        placeholder="{{ countryFloatLabel | translate }}"
                        formControlName="country"
                        id="country"
                        [filter]="true"
                        filterBy="name"
                        class="p-dropdown"
                        [options]="countries"
                        optionLabel="label"
                        inputId="float-label"
                        (onChange)="onChangeCountry($event)"
                    >
                        <ng-template pTemplate="selectedItem">
                            <div class="flex align-items-center gap-2" *ngIf="selectedCountry">
                                <span class="float-label-dropdown">{{ countryFloatLabel | translate }}</span>

                                <div class="data-field-value-dropdown-item-selected">
                                    {{ selectedCountry.name | titlecase }}
                                </div>
                            </div>
                        </ng-template>
                        <ng-template let-country pTemplate="item">
                            <div class="flex align-items-center gap-2">
                                <div class="selected-item-dropdown data-field-value-dropdown">
                                    {{ country.name  | titlecase}}
                                    <i *ngIf="country == selectedCountry" class="ri-check-line"></i>
                                </div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                </div>
            </div>
        </form>

        <div class="actions">
            <button
                *ngIf="!isPortraitDevice"
                pripple=""
                class="button-secondary button-next"
                type="button"
                [disabled]="backButtonDisabled"
                (click)="onClicButtonBack()"
            >
                <span class="ri-arrow-left-line p-button-icon p-button-icon-left ng-star-inserted"></span>
                <span class="p-button-label-right">{{ backButton | translate }}</span>
            </button>

            <button
                pripple=""
                class="button-primary button-next"
                type="button"
                [disabled]="continueButtonDisabled"
                (click)="onClicButtonContinue()"
                [ngClass]="{ 'is-portrait': isPortraitDevice }"
            >
                <span class="p-button-label-left">{{ continueButton | translate }}</span>
                <span class="ri-arrow-right-line p-button-icon p-button-icon-right ng-star-inserted"></span>
            </button>
        </div>
    </div>

    <div *ngIf="isPortraitDevice">
        <app-footer></app-footer>
    </div>

    <div class="chat-layer">
        <app-chat-layer></app-chat-layer>
    </div>
</div>
